export const STATUS_STYLE = {
  open: "bg-cyan-50 text-cyan-800 border-cyan-200",
  in_progress: "bg-yellow-50 text-yellow-800 border-yellow-300",
  resolved: "bg-emerald-50 text-emerald-800 border-emerald-200",
  closed: "bg-slate-100 text-slate-700 border-slate-300",
};

export const StatusPill = ({ status, testId }) => (
  <span data-testid={testId} className={`font-mono-x inline-block rounded-full border px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wider ${STATUS_STYLE[status] || STATUS_STYLE.open}`}>
    {String(status || "open").replace("_", " ")}
  </span>
);

const fmt = (d) => (d ? new Date(d).toLocaleString() : "");

export const Thread = ({ ticket, viewer = "customer" }) => {
  const msgs = [{ author: "customer", message: ticket?.message, created_at: ticket?.created_at }, ...(ticket?.replies || [])];
  return (
    <div className="space-y-3" data-testid="ticket-thread">
      {msgs.map((m, i) => {
        const mine = m.author === viewer;
        return (
          <div key={i} className={`flex ${mine ? "justify-end" : "justify-start"}`}>
            <div className={`max-w-[85%] rounded-2xl px-4 py-3 ${m.author === "support" ? "bg-blue-50 border border-blue-200" : "bg-white border border-slate-200"}`} data-testid={`thread-message-${i}`}>
              <p className="font-mono-x text-[11px] font-bold uppercase tracking-wider text-slate-600">{m.author === "support" ? "Start-A-TE Support" : ticket?.name || "Customer"} · {fmt(m.created_at)}</p>
              <p className="mt-1.5 whitespace-pre-wrap text-sm text-slate-800">{m.message}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
